import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';

export enum BundledFeaturesStatus {
  Active = 'active',
  Disable = 'disable',
}

export interface BundledFeaturesProps {
  code: string;
  label: string;
  stripeProductId: string;
  status: BundledFeaturesStatus;
  createdAt: Date;
  updatedAt?: Date | undefined;
  sort: number;
  features: string[];
  details: string[];
}

export class BundledFeaturesId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): BundledFeaturesId {
    return new BundledFeaturesId(id);
  }
}

export class BundledFeatures extends Entity<BundledFeaturesProps> {
  get bundledFeaturesId(): BundledFeaturesId {
    return BundledFeaturesId.create(this.id);
  }

  get code(): string {
    return this.props.code;
  }

  get label(): string {
    return this.props.label;
  }

  get sort(): number {
    return this.props.sort;
  }

  get stripeProductId(): string {
    return this.props.stripeProductId;
  }

  get status(): BundledFeaturesStatus {
    return this.props.status;
  }

  get features(): string[] {
    return this.props.features;
  }

  get details(): string[] {
    return this.props.details;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get updatedAt(): Date | undefined {
    return this.props.updatedAt;
  }

  private constructor(props: BundledFeaturesProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: BundledFeaturesProps): BundledFeatures {
    return BundledFeatures.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: BundledFeaturesProps,
    id?: UniqueEntityID,
  ): BundledFeatures {
    return new BundledFeatures(props, id);
  }
}
